var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5C17.5 12.8917 13.7217 16.5 9 16.5C4.27827 16.5 0.5 12.8917 0.5 8.5C0.5 4.10826 4.27827 0.5 9 0.5C13.7217 0.5 17.5 4.10826 17.5 8.5Z",
    fill: "white",
    stroke: "#957EF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7204 6.58931L10.4727 6.24715L9.46708 4.11291C9.29106 3.7402 8.70882 3.7402 8.53279 4.11291L7.52768 6.24715L5.27944 6.58931C4.85396 6.65425 4.68158 7.20431 4.99093 7.52082L6.61786 9.18194L6.23404 11.5279C6.16165 11.9721 6.60745 12.3132 6.9897 12.1031L8.99994 10.9959L11.0107 12.1036C11.3898 12.3115 11.8393 11.9759 11.7664 11.5285L11.3825 9.18249L13.0095 7.52137C13.3183 7.20431 13.1459 6.65425 12.7204 6.58931Z",
    fill: "#957EF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cf9254e8cb4ebd4eb2ce49c40b6ed74e.svg";
export { ForwardRef as ReactComponent };